import * as jose from "jose";

export function clientAccessTokenCookieOptions(accessToken: string) {
  const base = {
    path: "/",
    sameSite: "lax" as const,
    secure: process.env.NODE_ENV === "production",
  };
  try {
    const decoded = jose.decodeJwt(accessToken);
    const exp = decoded.exp;
    if (typeof exp !== "number") {
      return base;
    }
    const expMs = exp * 1000;
    const maxAge = Math.max(0, Math.floor((expMs - Date.now()) / 1000));
    if (maxAge <= 0) {
      return { ...base, maxAge: 0 };
    }
    return {
      ...base,
      expires: new Date(expMs),
      maxAge,
    };
  } catch {
    return base;
  }
}
